import { LOG_OUT, LOG_OUT_DEV } from 'stash/actions';

const segmentMiddleware = (analytics) => () => (next) => (action) => {
	switch (action.type) {
		case LOG_OUT:
		case LOG_OUT_DEV:
			analytics.reset();
			break;
		default:
			break;
	}
	return next(action);
};

export default segmentMiddleware;
